module.exports = __webpack_public_path__ + "img/ombra_nuvola.d6b2f26c.png";